module.exports = __webpack_public_path__ + "img/product8.b7cd530f.png";